export default {
  title: 'Feature Flags',
  subtitle: 'Activer ou désactiver les fonctionnalités pour {{company}}.',
  no_company: 'Sélectionnez un restaurant pour gérer ses feature flags.',
  columns: {
    feature: 'Fonctionnalité',
    status: 'Statut',
  },
  flags: {
    paypal_standalone: {
      name: 'PayPal (direct)',
      description:
        "Permet à ce restaurant d'accepter des paiements PayPal directement sur son propre compte PayPal. Activé par défaut pour les restaurants des partenaires facturés par Foodamigos, pour lesquels les frais de service client sont également appliqués à ces paiements et la part de la plateforme est facturée au partenaire.",
    },
    vip_free_flyers: {
      name: 'Flyers gratuits mensuels',
      description:
        'Envoyer automatiquement 500 flyers promotionnels chaque mois à ce restaurant (par défaut : activé pour les niveaux VIP et Star).',
    },
    custom_store_seo: {
      name: 'SEO personnalisé de la boutique',
      description: 'Permettre à ce restaurant de gérer les paramètres SEO personnalisés de sa boutique en ligne.',
    },
    external_printer: {
      name: 'Imprimante de reçus externe',
      description:
        "Permettre à ce restaurant de connecter une imprimante réseau à l'application de terminal de commande, au lieu d'utiliser l'imprimante intégrée du terminal.",
    },
    stripe_payment_element: {
      name: 'Paiement avec Stripe Payment Element',
      description:
        "Laisser le compte Stripe du restaurant décider des moyens de paiement proposés au paiement. N'activez cette option qu'une fois les moyens de paiement pour comptes connectés configurés sur sa plateforme Stripe.",
    },
  },
  toasts: {
    enabled: 'Fonctionnalité activée.',
    disabled: 'Fonctionnalité désactivée.',
    error: 'Impossible de mettre à jour la fonctionnalité. Veuillez réessayer.',
    load_error: 'Impossible de charger les feature flags.',
  },
};
